






































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import store from '@/store';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasInfoTooltipTemplate from '@/views/AmetrasInfoTooltipTemplate.vue';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import SelectEvent from '@/types/selectEvent';
import AmetrasLabelTemplate from '@/fields/AmetrasLabelTemplate.vue';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import '@/compiled-icons/alarm-plus';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import AmetrasFormularWrapper from '@/views/AmetrasFormularWrapper.vue';

/** No mechanic row is waiting for a vehicle selection. */
const NO_MECHANIC_SELECTED = -1;

/**
 * Row of the vehicle selection table. The vehicle table is a trampolin table, so
 * its type is not part of the generated DisguiseDto namespace.
 */
interface VehicleSelectionEntry {
  companyNo?: number;
  machineNo?: string;
  licensePlate?: string;
  make?: string;
  type?: string;
}

/**
 * General Component for Fields of type COSL
 */
@Component({
  components: {
    AmetrasFormularWrapper,
    AmetrasTextAreaFieldTemplate,
    AmetrasLabelTemplate,
    AmetrasInfoTooltipTemplate,
    AmetrasCheckBoxTemplate,
    DataTableTemplate: () => import('@/views/datatable/DataTableTemplate.vue')
  }
})
export default class AmetrasMechanicSearchTemplate extends Vue {
  @Prop() marginDefinition!: string;
  @Prop() paddingDefinition!: string;
  @Prop() templateUrl!: string;
  @Prop() label!: string;
  @Prop() typeSpecificSettings!: DisguiseDto.FieldTypeSpecificSettingsUnion;
  @Prop() readonly!: boolean;
  @Prop({
    default: false
  }) mandatory!: boolean;
  @Prop({
    type: Array as () => DisguiseDto.MechanicDto[]
  }) value!: DisguiseDto.MechanicDto[];
  @Prop({
    type: Array as () => string[]
  }) selectValues!: string[];
  dialogOpenSelectMechanic: boolean = false;
  dialogOpenSelectVehicle: boolean = false;
  vehicleSelectionMechanicIndex: number = NO_MECHANIC_SELECTED;
  editWorkTimePermissionDialogOpened: boolean = false;
  workTimePermissionValid: boolean = false;
  mechanicPermissions: {
    mechIndex?: number;
    effortReportTimeRestrictionDisabled?: boolean;
    effortReportTimeRestrictionReason?: string;
    effortReportPaidBreakDisabled?: boolean;
    effortReportPaidBreakReason?: string;
  } = {};

  displayExemptions: boolean = false;
  displayTeamLead: boolean = false;
  displayInternalProjectFlag: boolean = false;
  displayVehicle: boolean = false;
  vehicleTableSource: string = '';


  $refs!: {
    formWrapper: AmetrasFormularWrapper
  };

  mechanicRules = [(value: DisguiseDto.SelectDto[]) => {
    if (this.mandatory && value.length === 0) {
      return 'Bitte einen Monteur auswählen!';
    }
    return true;
  }];

  created() {
    if (this.typeSpecificSettings && this.typeSpecificSettings['@type'] === 'MechanicSearchFieldSpecificSettings') {
      const castedSetting = this.typeSpecificSettings as DisguiseDto.MechanicSearchFieldSpecificSettings;
      this.displayExemptions = castedSetting.displayExemptions || false;
      this.displayTeamLead = castedSetting.displayTeamLead || false;
      this.displayInternalProjectFlag = castedSetting.displayInternalProjectFlag || false;
      this.displayVehicle = castedSetting.displayVehicle || false;
      this.vehicleTableSource = castedSetting.vehicleTableSource || '';
    }
  }

  handleSelectionOfMechanic(selectEvent: SelectEvent) {
    HTTP_SERVICE_INSTANCE.getAxios().get(selectEvent.url).then((response) => {
      const entry: DisguiseDto.MechanicEntityDto = response.data;
      if (entry) {
        // is this mechanic already added?
        let keyAlreadyExists = false;
        for (const currentEntry of this.value) {
          const mechanicIdentifierMatches = currentEntry.mechanicIdentifier === entry.mechanicIdentifier;
          const mechanicCompanyMatches = currentEntry.companyId === entry.companyNo;
          if (mechanicIdentifierMatches && mechanicCompanyMatches) {
            keyAlreadyExists = true;
            break;
          }
        }

        if (keyAlreadyExists) {
          store.commit('showSnack', {
            message: 'Mechaniker wurde bereits hinzugefügt.',
            color: 'error'
          });
        } else {
          const newMechanicEntry: DisguiseDto.MechanicDto = {
            mechanicIdentifier: entry.mechanicIdentifier,
            companyId: entry.companyNo,
            name: entry.name,
            vehicles: []
          };
          this.value.push(newMechanicEntry);
        }
        this.dialogOpenSelectMechanic = false;

      }
    }, (error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: 'Datenabruf fehlgeschlagen.',
          color: 'error'
        });
      }
    });
  }

  removeMechanic(mechanic: DisguiseDto.MechanicDto): void {
    const mechIndex = this.value.indexOf(mechanic);
    this.value.splice(mechIndex, 1);
  }

  hasVehicles(mechanic: DisguiseDto.MechanicDto): boolean {
    return (mechanic.vehicles || []).length > 0;
  }

  openVehicleSelection(mechanic: DisguiseDto.MechanicDto): void {
    this.vehicleSelectionMechanicIndex = this.value.indexOf(mechanic);
    this.dialogOpenSelectVehicle = true;
  }

  closeVehicleSelection(): void {
    this.dialogOpenSelectVehicle = false;
    this.vehicleSelectionMechanicIndex = NO_MECHANIC_SELECTED;
  }

  handleSelectionOfVehicle(selectEvent: SelectEvent) {
    const mechanicIndex = this.vehicleSelectionMechanicIndex;
    if (mechanicIndex === NO_MECHANIC_SELECTED) {
      return;
    }
    HTTP_SERVICE_INSTANCE.getAxios().get(selectEvent.url).then((response) => {
      const entry: VehicleSelectionEntry = response.data;
      if (entry) {
        this.addVehicle(this.value[mechanicIndex], {
          companyNo: entry.companyNo,
          machineNo: entry.machineNo,
          licensePlate: entry.licensePlate || '',
          description: this.buildVehicleDescription(entry)
        });
      }
      this.closeVehicleSelection();
    }, (error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: 'Datenabruf fehlgeschlagen.',
          color: 'error'
        });
      }
    });
  }

  removeVehicle(mechanic: DisguiseDto.MechanicDto, vehicle: DisguiseDto.MechanicVehicleDto): void {
    const vehicles = mechanic.vehicles || [];
    const vehicleIndex = vehicles.indexOf(vehicle);
    if (vehicleIndex >= 0) {
      vehicles.splice(vehicleIndex, 1);
    }
  }

  editWorkTimePermission(mechanic: DisguiseDto.MechanicDto): void {
    const mechIndex = this.value.indexOf(mechanic);
    this.mechanicPermissions = {
      mechIndex,
      effortReportTimeRestrictionDisabled: mechanic.effortReportTimeRestrictionDisabled || false,
      effortReportTimeRestrictionReason: mechanic.effortReportTimeRestrictionReason || '',
      effortReportPaidBreakDisabled: mechanic.effortReportPaidBreakDisabled || false,
      effortReportPaidBreakReason: mechanic.effortReportPaidBreakReason || '',
    };
    this.editWorkTimePermissionDialogOpened = true;
  }



  saveWorkTimePermission(): void {
    if (this.$refs.formWrapper.validate()) {
      if (this.mechanicPermissions.mechIndex !== undefined) {
        const toBeModifiedMechanicObj = this.value[this.mechanicPermissions.mechIndex];
        toBeModifiedMechanicObj.effortReportTimeRestrictionDisabled = this.mechanicPermissions.effortReportTimeRestrictionDisabled || false;
        toBeModifiedMechanicObj.effortReportTimeRestrictionReason = this.mechanicPermissions.effortReportTimeRestrictionDisabled ? this.mechanicPermissions.effortReportTimeRestrictionReason || '' : '';
        toBeModifiedMechanicObj.effortReportPaidBreakDisabled = this.mechanicPermissions.effortReportPaidBreakDisabled || false;
        toBeModifiedMechanicObj.effortReportPaidBreakReason = this.mechanicPermissions.effortReportPaidBreakDisabled ? this.mechanicPermissions.effortReportPaidBreakReason || '' : '';
      }
      this.mechanicPermissions = {};
      this.editWorkTimePermissionDialogOpened = false;
    }
  }

  private addVehicle(mechanic: DisguiseDto.MechanicDto, vehicle: DisguiseDto.MechanicVehicleDto): void {
    const vehicles = mechanic.vehicles || [];
    if (vehicles.some((assignedVehicle) => this.isSameVehicle(assignedVehicle, vehicle))) {
      return;
    }
    if (mechanic.vehicles) {
      mechanic.vehicles.push(vehicle);
    } else {
      this.$set(mechanic, 'vehicles', [vehicle]);
    }
  }

  private isSameVehicle(first: DisguiseDto.MechanicVehicleDto, second: DisguiseDto.MechanicVehicleDto): boolean {
    return first.companyNo === second.companyNo
        && (first.machineNo || '').trimEnd() === (second.machineNo || '').trimEnd();
  }

  private buildVehicleDescription(entry: VehicleSelectionEntry): string {
    return [entry.make, entry.type]
        .map((descriptionPart) => (descriptionPart || '').trim())
        .filter((descriptionPart) => descriptionPart.length > 0)
        .join(' ');
  }

}

